export default __webpack_public_path__ + "static/media/skill-adlibs.6c56a271.svg";